import { Component, Input, Output, EventEmitter, HostListener, ElementRef, ViewChild, ViewChildren, OnInit, OnDestroy } from '@angular/core';

import { Size } from 'app/shared/models/size';
import {ISubscription} from "rxjs/Subscription";
import {CommonService} from "../services/common.service";
import {MainHelper} from "../shared/models/main-helper";
import {b, v} from "@angular/core/src/render3";

export enum ResizeDirection {
    BottomRight = 0,
    Vertical = 1,
    Horizontal = 2
}

@Component({
    selector: 'resize-glyph',
    templateUrl: './resize-glyph.component.html',
    styleUrls: ['resize-glyph.component.css']
})
export class ResizeGlyphComponent implements OnInit, OnDestroy {
    constructor(private readonly elementRef: ElementRef, private readonly commonService: CommonService) {
        this.resizeDirection = ResizeDirection.BottomRight;
        this.resizeBy = new EventEmitter<Size>();
        this.hideResizer = new EventEmitter<boolean>();
        this._disableResize = false;
        this.helper = new MainHelper();
        // this.cssClass = '';
    }

    public direction: ResizeDirection;
    @Input('direction')
    set resizeDirection(value: ResizeDirection) {
        this.direction = value;
        this.setClasses();
    }

    private _disableResize: boolean;
    @Input('disableResize')
    set disableResize(value: boolean) {
        this.helper.wait(() => {
            if (value !== this._disableResize){
                this._disableResize = value;
                this.setClasses(value);

            }
        })

    }

    get disableResize(): boolean {
        return this._disableResize
    }

    @Input()
    private cssClassIn: string[];

    @Input()
    public showHideButton?: boolean;

    @Input()
    public hideButtonTooltip?: string;

    @Output()
    private readonly resizeBy: EventEmitter<Size>;

    @Output()
    private readonly hideResizer: EventEmitter<boolean>;

    @ViewChild('glyph')
    private glyph: ElementRef;

    @ViewChildren('glyphChild')
    private glyphChildren: ElementRef[];

    public cssClass: string;

    public mouseDown: boolean;

    public cursor: string;

    private lastX: number;

    private lastY: number;

    private helper: MainHelper;

    private subscriptionMouseMove: ISubscription;

    ngOnInit(){
        this.addCssClassIn();
        // this.subscriptionMouseMove = this.commonService.mouseMoveCurrent.subscribe(res => { console.log(res, 'subscriptionMouseMove'); res ? this.onMouseMove(res) : null} );
    }

    ngOnDestroy(){
        // this.subscriptionMouseMove.unsubscribe();
    }


    @HostListener('window:mousedown', ['$event'])
    private onMouseDown = (event: MouseEvent): void => {
        if (event.button !== 0 ||
        (event.target !== this.glyph.nativeElement &&
            this.glyphChildren.find(e => event.target === e.nativeElement) == null))
            return;

        this.mouseDown = true;
        this.lastX = event.screenX;
        this.lastY = event.screenY;
    }

    @HostListener('window:mouseup', ['$event'])
    private onMouseUp = (event: MouseEvent): void => {
        if (event.button === 0)
            this.mouseDown = false;
    }

    @HostListener('window:mousemove', ['$event'])
    private onMouseMove = (event: MouseEvent): void => {
        if (!this.mouseDown)
            return;

        const movementX = event.screenX - this.lastX;
        const movementY = event.screenY - this.lastY;
        this.lastX = event.screenX;
        this.lastY = event.screenY;
        if (movementX !== 0 || movementY !== 0)
            this.resizeBy.emit(new Size(movementX, movementY));
    }

    private setClasses = (disable: boolean = false): void => {
        this.cssClass = '';
        let cssClass = 'resize-glyph ';
        switch(this.direction) {
            case ResizeDirection.BottomRight:
            default:
                cssClass += 'resize-glyph-bottom-right';
                this.cursor = 'nwse-resize';
                break;
            case ResizeDirection.Vertical:
                cssClass += 'resize-glyph-vertical';
                this.cursor = 'ns-resize';
                break;
            case ResizeDirection.Horizontal:
                cssClass += 'resize-glyph-horizontal';
                this.cursor = 'ew-resize';
                break;
        }
        if(disable){
            this.cursor = '';
        }
        this.cssClass += cssClass;
        this.addCssClassIn();
    }

    private addCssClassIn = (): void => {
        this.cssClassIn && this.cssClassIn.length ? this.cssClass += ` ${this.cssClassIn.join(' ')}` : null;
    }

    public readonly onHideResizer = (val: boolean): void => {
        this.hideResizer.emit(val);
    }
}



// WEBPACK FOOTER //
// ./src/app/resize-glyph/resize-glyph.component.ts